import { PERMISSIONS } from './permission';

export const COMPANY_ROLE_GROUPS = {
  auth: {
    auth_edit: PERMISSIONS.auth_edit,
    auth_setting: PERMISSIONS.auth_setting,
  },
  project: {
    project_view: PERMISSIONS.project_view,
    project_create: PERMISSIONS.project_create,
    project_edit: PERMISSIONS.project_edit,
    project_delete: PERMISSIONS.project_delete,
    projectTask: {
      projectTask_view: PERMISSIONS.projectTask_view,
      projectTask_create: PERMISSIONS.projectTask_create,
      projectTask_edit: PERMISSIONS.projectTask_edit,
      projectTask_delete: PERMISSIONS.projectTask_delete,
    },
    projectEstimate: {
      projectEstimate_view: PERMISSIONS.projectEstimate_view,
      projectEstimate_create: PERMISSIONS.projectEstimate_create,
      projectEstimate_edit: PERMISSIONS.projectEstimate_edit,
      projectEstimate_delete: PERMISSIONS.projectEstimate_delete,
      projectEstimate_esign: PERMISSIONS.projectEstimate_esign,
    },
    projectNote: {
      projectNote_view: PERMISSIONS.projectNote_view,
      projectNote_create: PERMISSIONS.projectNote_create,
      projectNote_edit: PERMISSIONS.projectNote_edit,
      projectNote_delete: PERMISSIONS.projectNote_delete,
    },
    projectActivity: {
      projectActivity_view: PERMISSIONS.projectActivity_view,
    },
    projectFile: {
      projectFile_view: PERMISSIONS.projectFile_view,
      projectFile_create: PERMISSIONS.projectFile_create,
      projectFile_edit: PERMISSIONS.projectFile_edit,
      projectFile_delete: PERMISSIONS.projectFile_delete,
      projectFile_report: PERMISSIONS.projectFile_report,
    },
    projectFinancial: {
      projectFinancial_view: PERMISSIONS.projectFinancial_view,
    },
    projectAreaScope: {
      projectAreaScope_view: PERMISSIONS.projectAreaScope_view,
      projectAreaScope_create: PERMISSIONS.projectAreaScope_create,
      projectAreaScope_edit: PERMISSIONS.projectAreaScope_edit,
      projectAreaScope_delete: PERMISSIONS.projectAreaScope_delete,
    },
    cogs: {
      cogs_view: PERMISSIONS.cogs_view,
      cogs_create: PERMISSIONS.cogs_create,
      cogs_edit: PERMISSIONS.cogs_edit,
      cogs_delete: PERMISSIONS.cogs_delete,
    },
  },
  account: {
    account_view: PERMISSIONS.account_view,
    account_create: PERMISSIONS.account_create,
    account_edit: PERMISSIONS.account_edit,
    account_delete: PERMISSIONS.account_delete,
  },
  schedule: {
    schedule_view: PERMISSIONS.schedule_view,
    schedule_create: PERMISSIONS.schedule_create,
    schedule_edit: PERMISSIONS.schedule_edit,
    schedule_delete: PERMISSIONS.schedule_delete,
  },
  organization: {
    organization_view: PERMISSIONS.organization_view,
    organization_create: PERMISSIONS.organization_create,
    organization_edit: PERMISSIONS.organization_edit,
    organization_delete: PERMISSIONS.organization_delete,
    organizationTask: {
      organizationTask_view: PERMISSIONS.organizationTask_view,
      organizationTask_create: PERMISSIONS.organizationTask_create,
      organizationTask_edit: PERMISSIONS.organizationTask_edit,
      organizationTask_delete: PERMISSIONS.organizationTask_delete,
    },
    organizationNote: {
      organizationNote_view: PERMISSIONS.organizationNote_view,
      organizationNote_create: PERMISSIONS.organizationNote_create,
      organizationNote_edit: PERMISSIONS.organizationNote_edit,
      organizationNote_delete: PERMISSIONS.organizationNote_delete,
    },
    organizationActivity: {
      organizationActivity_view: PERMISSIONS.organizationActivity_view,
    },
    organizationFile: {
      organizationFile_view: PERMISSIONS.organizationFile_view,
      organizationFile_create: PERMISSIONS.organizationFile_create,
      organizationFile_edit: PERMISSIONS.organizationFile_edit,
      organizationFile_delete: PERMISSIONS.organizationFile_delete,
    },
  },
  contact: {
    contact_view: PERMISSIONS.contact_view,
    contact_create: PERMISSIONS.contact_create,
    contact_edit: PERMISSIONS.contact_edit,
    contact_delete: PERMISSIONS.contact_delete,
    contactTask: {
      contactTask_view: PERMISSIONS.contactTask_view,
      contactTask_create: PERMISSIONS.contactTask_create,
      contactTask_edit: PERMISSIONS.contactTask_edit,
      contactTask_delete: PERMISSIONS.contactTask_delete,
    },
    contactNote: {
      contactNote_view: PERMISSIONS.contactNote_view,
      contactNote_create: PERMISSIONS.contactNote_create,
      contactNote_edit: PERMISSIONS.contactNote_edit,
      contactNote_delete: PERMISSIONS.contactNote_delete,
    },
    contactActivity: {
      contactActivity_view: PERMISSIONS.contactActivity_view,
    },
    contactFile: {
      contactFile_view: PERMISSIONS.contactFile_view,
      contactFile_create: PERMISSIONS.contactFile_create,
      contactFile_edit: PERMISSIONS.contactFile_edit,
      contactFile_delete: PERMISSIONS.contactFile_delete,
    },
  },
  crm: {
    crm_view: PERMISSIONS.crm_view,
    crm_edit: PERMISSIONS.crm_edit,
    crmStatus: {
      crmStatus_view: PERMISSIONS.crmStatus_view,
      crmStatus_create: PERMISSIONS.crmStatus_create,
      crmStatus_edit: PERMISSIONS.crmStatus_edit,
      crmStatus_delete: PERMISSIONS.crmStatus_delete,
    },
  },
  timeClock: {
    timeClock_view: PERMISSIONS.timeClock_view,
    timeClock_viewAll: PERMISSIONS.timeClock_viewAll,
    timeClock_create: PERMISSIONS.timeClock_create,
    timeClock_edit: PERMISSIONS.timeClock_edit,
    timeClock_delete: PERMISSIONS.timeClock_delete,
    timeClock_export: PERMISSIONS.timeClock_export,
  },
  invoice: {
    invoice_view: PERMISSIONS.invoice_view,
    invoice_create: PERMISSIONS.invoice_create,
    invoice_edit: PERMISSIONS.invoice_edit,
    invoice_delete: PERMISSIONS.invoice_delete,
  },
  priceItem: {
    priceItem_view: PERMISSIONS.priceItem_view,
    priceItem_create: PERMISSIONS.priceItem_create,
    priceItem_edit: PERMISSIONS.priceItem_edit,
    priceItem_delete: PERMISSIONS.priceItem_delete,
  },
  report: {
    report_view: PERMISSIONS.report_view,
  },
  template: {
    estimateTemplate: {
      estimateTemplate_view: PERMISSIONS.estimateTemplate_view,
      estimateTemplate_create: PERMISSIONS.estimateTemplate_create,
      estimateTemplate_edit: PERMISSIONS.estimateTemplate_edit,
      estimateTemplate_delete: PERMISSIONS.estimateTemplate_delete,
    },
    openingStatementTemplate: {
      openingStatementTemplate_view: PERMISSIONS.openingStatementTemplate_view,
      openingStatementTemplate_create: PERMISSIONS.openingStatementTemplate_create,
      openingStatementTemplate_edit: PERMISSIONS.openingStatementTemplate_edit,
      openingStatementTemplate_delete: PERMISSIONS.openingStatementTemplate_delete,
    },
    estimateTermTemplate: {
      estimateTermTemplate_view: PERMISSIONS.estimateTermTemplate_view,
      estimateTermTemplate_create: PERMISSIONS.estimateTermTemplate_create,
      estimateTermTemplate_edit: PERMISSIONS.estimateTermTemplate_edit,
      estimateTermTemplate_delete: PERMISSIONS.estimateTermTemplate_delete,
    },
    emailTemplate: {
      emailTemplate_view: PERMISSIONS.emailTemplate_view,
      emailTemplate_create: PERMISSIONS.emailTemplate_create,
      emailTemplate_edit: PERMISSIONS.emailTemplate_edit,
      emailTemplate_delete: PERMISSIONS.emailTemplate_delete,
    },
  },
  companyTask: {
    companyTask_view: PERMISSIONS.companyTask_view,
    companyTask_create: PERMISSIONS.companyTask_create,
    companyTask_edit: PERMISSIONS.companyTask_edit,
    companyTask_delete: PERMISSIONS.companyTask_delete,
  },
  setting: {
    quickbooks: {
      quickbooks_connect: PERMISSIONS.quickbooks_connect,
      quickbooks_view: PERMISSIONS.quickbooks_view,
    },
    ringCentral: {
      ringCentral_connect: PERMISSIONS.ringCentral_connect,
    },
    location: {
      location_view: PERMISSIONS.location_view,
      location_create: PERMISSIONS.location_create,
      location_edit: PERMISSIONS.location_edit,
      location_delete: PERMISSIONS.location_delete,
    },
    companyRole: {
      companyRole_view: PERMISSIONS.companyRole_view,
      companyRole_create: PERMISSIONS.companyRole_create,
      companyRole_edit: PERMISSIONS.companyRole_edit,
      companyRole_delete: PERMISSIONS.companyRole_delete,
    },
    crmStatusSetting: {
      crmStatusSetting_view: PERMISSIONS.crmStatusSetting_view,
      crmStatusSetting_create: PERMISSIONS.crmStatusSetting_create,
      crmStatusSetting_edit: PERMISSIONS.crmStatusSetting_edit,
      crmStatusSetting_delete: PERMISSIONS.crmStatusSetting_delete,
    },
    equipment: {
      equipment_view: PERMISSIONS.equipment_view,
      equipment_create: PERMISSIONS.equipment_create,
      equipment_edit: PERMISSIONS.equipment_edit,
      equipment_delete: PERMISSIONS.equipment_delete,
    },
    projectStatus: {
      projectStatus_view: PERMISSIONS.projectStatus_view,
      projectStatus_create: PERMISSIONS.projectStatus_create,
      projectStatus_edit: PERMISSIONS.projectStatus_edit,
      projectStatus_delete: PERMISSIONS.projectStatus_delete,
    },
  },
};
